import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import okc__asset from "@/assets/restore/locations/oklahoma-city.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Oklahoma City",
    serviceArea: "oklahoma-city",
    address: "101 Park Ave, Suite 1300",
    img: okc__asset.url,
    mapUrl: map("101 Park Ave Oklahoma City OK"),
    to: "/locations/oklahoma/oklahoma-city/",
  },
];

export const Route = createFileRoute("/locations/oklahoma/")({
  head: () => ({
    meta: [
      { title: "Oklahoma Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Oklahoma. Book a free personal hair loss consultation at our Oklahoma City location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Oklahoma Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Oklahoma City and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/oklahoma/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/oklahoma/" }],
  }),
  component: () => <StateLocationsHub stateName="Oklahoma" cities={cities} />,
});